import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    templateUrl: './deeplink.component.html',
    styleUrls: ['./deeplink.component.scss']
})
export class DeepLinkComponent implements OnInit, OnDestroy {
    private subs: Subscription[] = [];

    private deepLinkSchema: string = '';

    constructor(
        private activatedRoute: ActivatedRoute,
    ) {
        this.activatedRoute.queryParams.subscribe(params => {
            if (params && params['ref']) {
                this.deepLinkSchema = params['ref'];
            }
        });
    }

    ngOnInit(): void {
        console.log('init DeepLinkComponent', this.deepLinkSchema)
        if (!!this.deepLinkSchema) {
            location.replace('cortizoapp://' + this.deepLinkSchema);
        }
    }

    ngOnDestroy(): void {
        this.subs.map(s => s.unsubscribe());
    }

    openApp(): void {
        if (!!this.deepLinkSchema) {
            location.replace('cortizoapp://' + this.deepLinkSchema);
        }
    }
}

